// extracted by mini-css-extract-plugin
export default {"main":"FormCheckbox_main__1qPpz","label":"FormCheckbox_label__zEDoI"};